export const COMMON_STYLES = {
  labelClasses: "flex w-full pl-1 text-xs font-medium",
  disabledClass: "opacity-50",
};
